
import { MODULE } from "@/config/modules";
import { Contact } from "@/models/base";
import { AuthService } from "@/services/auth-service";
import Vue from "vue";
import AppMissingModule from "@/components/common/MissingModule.vue";

export default Vue.extend({
	props: {
		contact: {
			type: Object as ()=>Contact,
			required: true
		}
	},
	computed: {
		isAllowed(): Boolean {
			return AuthService.hasModule(this.moduleId);
		},
		moduleId():number {
			return MODULE.PRIJSBEDING;
		},
	},
	components: {
		AppMissingModule
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
